<div class="com-pr-custom-group-header">
    <div class="customHeaderLabel icon-green-inline-tick">
        <span tooltip [tooltipTitle]="params.displayName" [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>{{ params.displayName }}</span>
    </div>
</div>